import * as React from 'react';
import {Navigate} from "react-router-dom";
import {AuthService} from "./service/AuthService";
import {isAdmin} from "./utils/Utils";

// Route guard for admin-only pages. Redirects non-admins to the dashboard
// (and unauthenticated users to login).
export function AdminRequiredRoute({children}) {
    if (!AuthService.loggedIn())
        return <Navigate to="/login"/>;
    if (!isAdmin())
        return <Navigate to="/"/>;
    return children;
}
